export default __webpack_public_path__ + "static/media/loading.9f74b107.svg";